export default {
  '请求': {
    '加载中': 'A carregar',
    '请求失败': 'Pedido falhou',
    '登录已过期': 'Sessão expirada',
    '网络连接失败': 'Falha na ligação de rede',
    '请重新登录': 'Inicie sessão novamente',
    '没有权限访问': 'Acesso negado',
    '请求的资源不存在': 'Recurso não encontrado',
    '服务器错误': 'Erro do servidor',
    '网络错误': 'Erro de rede',
    '刷新成功': 'Atualizado',
    '获取中': 'A carregar......',
    '账号下线': 'Conta offline',
    '功能已禁用': 'Funcionalidade desativada',
  },
  '导航': {
    '首页': 'Início',
    '选妃': 'Escolher',
    '认证': 'Verificar',
    '影院': 'Vídeo',
    '个人': 'Meu',
  },
  '首页': {
    '注册': 'Registar',
    '影片': 'Vídeo',
    '女团': 'Raparigas',
    '热门城市': 'Cidades populares:',
    '经理预订': 'Reserva do gestor',
    '看更多': 'Mais',
    '身份验证': 'Verificado',
    '身高': 'Altura',
    '胸围': 'Busto',
    '服务城市': 'Cidade:',
  },
  '女团': {
    '女团': 'Raparigas',
    '选妃': 'Escolher',
    '身份验证': 'Verificado',
    '身高': 'Altura',
    '胸围': 'Busto',
    '服务城市': 'Cidade:',
    '注册': 'Registar',
    '请联系顾问或接待员': 'Contacte um consultor',
  },
  '登录': {
    '登录会员视窗': 'Início de sessão de membro',
    '请输入用户名': 'Nome de utilizador',
    '请输入密码': 'Palavra-passe',
    '登录': 'Iniciar sessão',
    '没有账号马上注册': 'Sem conta? Registe-se',
    '登录成功': 'Sessão iniciada com sucesso',
    '登录注册': 'Iniciar sessão / Registar',
    '登录可享受更多服务': 'Inicie sessão para mais serviços!',
  },
  '注册': {
    '注册': 'Registar',
    '登录': 'Iniciar sessão',
    '请输入用户名': 'Nome de utilizador',
    '用户名规则': '6-20 letras/números',
    '请输入密码': 'Palavra-passe',
    '密码规则': '6-16 letras e números',
    '请输入验证码': 'Captcha',
    '验证码规则': 'Introduza o captcha de 4 dígitos',
    '请输入邀请码': 'Código de convite',
    '邀请码规则': 'Introduza o código de convite do agente',
    '同意协议': 'Tenho 18+ e aceito os Termos',
    '立即注册': 'Registar agora',
    '注册中': 'A registar...',
    '已有账号马上登录': 'Já tem conta? Iniciar sessão',
    '注册成功': 'Registado!',
    '注册失败': 'Falha no registo: ',
    '验证码错误': 'Captcha inválido',
    '请同意注册条款': 'Aceite os termos',
    '用户名已存在': 'Nome de utilizador já existe',
    '邀请码无效': 'Código de convite inválido',
  },
  '抢单': {
    '今日收益': 'Rendimento de hoje',
    '余额': 'Saldo',
    '订单': 'Encomendas',
    '开始抢单': 'Obter encomenda',
    '当前等级': 'Nível:',
    '提现': 'Levantar',
    '在线客服': 'Suporte',
    '充值': 'Carregar',
    '幸运任务': 'Tarefa da sorte',
    '幸运订单': 'Encomenda da sorte',
    '幸运订单提示': 'Parabéns! Encomenda com comissão alta',
    '恭喜获得幸运订单': 'Encomenda da sorte!',
    '提交订单': 'Submeter encomenda',
    '未完成订单提示': 'Tem uma encomenda por pagar. Pague primeiro.',
    '正在获取订单': 'A carregar encomenda...',
    '抢单时间': 'Hora de obtenção:',
    '订单号': 'N.º da encomenda',
    '订单总额': 'Total',
    '佣金': 'Comissão',
    '商品单价': 'Preço',
    '预计收入': 'Ganhos est.',
    '确认支付': 'Pagar agora',
    '确认付款': 'Confirmar pagamento',
    '支付处理中': 'A processar...',
    '取消': 'Cancelar',
    '去查看': 'Ver',
    '暂无可用订单': 'Sem encomendas disponíveis',
    '正在加载用户信息': 'A carregar info do utilizador...',
    '今日抢单已达上限': 'Limite diário atingido',
    '余额不足无法获取订单': 'Saldo insuficiente',
    '获取订单失败': 'Falha ao obter encomenda',
    '支付成功': 'Pagamento bem-sucedido',
    '支付失败': 'Pagamento falhou',
    '支付失败请重试': 'Pagamento falhou, tente novamente',
    '请完成任务单后进入': 'Conclua as tarefas primeiro',
    '请设置收款卡': 'Associe um endereço de levantamento',,
    '当前余额': 'Saldo atual',
    '还需缴纳': 'Valor a pagar',
  },
  '我的': {
    '我的页面': 'A minha página',
    '钻石': 'Diamante',
    '信誉分': 'Crédito',
    '开通专属会员': 'Ativar VIP',
    '开启一次日期不限': 'Desbloqueio único, sem limite de data',
    '提现': 'Levantar',
    '历史订单': 'Histórico de encomendas',
    '充值记录': 'Histórico de carregamentos',
    '提现记录': 'Histórico de levantamentos',
    '添加钱包地址': 'Adicionar endereço da carteira',
    '邀请码': 'Código de convite:',
    '余额': 'Saldo',
    '退出登陆': 'Terminar sessão',
  },
  '会员': {
    '会员等级': 'Adesão:',
    '普通等级': 'Normal',
    '当前等级': 'Atual',
    '立即开通': 'Ativar',
    '免费说明': '(Vídeos grátis) (Correspondência grátis)',
    '所需投资': 'Investimento necessário',
    '佣金': 'Comissão',
    '订单': 'Encomendas',
    '加入': 'Juntar-se >>',
  },
  '充值': {
    '充值': 'Carregar',
    '当前余额': 'Saldo',
    '余额': 'Saldo: ',
    '个': '',
    '充值金额': 'Montante',
    '请输入充值金额': 'Introduza o montante',
    '快速选择金额': 'Montante rápido',
    '确认': 'Confirmar',
    '提示': 'Dica',
    '金额错误': 'Montante inválido',
    '立即充值': 'Carregar agora',
    '提交成功': 'Submetido, aguarda revisão',
  },
  '提现': {
    '提现': 'Levantar',
    '兑换积分': 'Levantar pontos',
    '最大提款金额': 'Montante máx.',
    '资金密码': 'Palavra-passe de fundos',
    '余额': 'Saldo: ',
    '个': '',
    '钱包地址': 'Endereço da carteira: ',
    '请选择提款地址': 'Selecione o endereço de levantamento',
    '暂无绑定地址': 'Ainda sem endereço associado',
    '提交': 'Submeter',
    '通知': 'Aviso:',
    '单笔最大提现': '1. Máx. por levantamento: ',
    '单笔最低提现': '2. Mín. por levantamento: ',
    '检查姓名账号': '3. Verifique o nome e a conta',
    '注意提款费用': '4. Atenção às taxas de levantamento',
    '请填写正确的金额': 'Introduza um montante válido',
    '当前余额': 'Saldo',
    '提现金额': 'Montante',
    '请输入提现数量': 'Introduza o montante',
    '立即提现': 'Levantar agora',
    '交易密码': 'Palavra-passe de pagamento',
    '请输入交易密码': 'Introduza a palavra-passe de pagamento',
    '请先设置提现密码': 'Defina primeiro a palavra-passe de levantamento',
  },
  '绑卡': {
    '添加钱包地址': 'Adicionar endereço da carteira',
    '钱包地址信息': 'Dados da carteira',
    '请输入支付卡信息': 'Introduza o seu endereço da carteira',
    '加密货币类型': 'Tipo de cripto',
    '请选择加密货币类型': 'Selecione o tipo de cripto',
    '钱包地址': 'Endereço da carteira',
    '请输入钱包地址': 'Introduza o endereço da carteira',
    '绑卡说明': 'Caro utilizador, para a segurança dos fundos associe o seu nome verdadeiro e defina uma palavra-passe de levantamento. O nome deve coincidir com a conta.',
    '确定绑卡': 'Confirmar associação',
    '绑卡提示': 'Dica: associe um banco principal. Contacte o suporte para alterar.',
    '请先设置姓名': 'Defina o nome antes de associar!',
    '已绑定不可修改': 'Endereço já associado. Contacte o suporte para alterar.',
  },
  '订单历史': {
    '订单历史': 'Histórico de encomendas',
    '数据为空': 'Sem dados',
    '订单号': 'N.º da encomenda: ',
    '已完成': 'Concluído',
    '处理中': 'Em processamento',
    '完成订单': 'Concluir encomenda',
    '订单金额': 'Montante: ',
    '佣金': 'Comissão: ',
    '创建时间': 'Criado: ',
    '上一页': 'Ant.',
    '下一页': 'Seg.',
    '获取失败': 'Falha ao carregar histórico',
    '获取失败重试': 'Falha ao carregar, tente novamente',
    '未知': 'Desconhecido',
    '完成成功': 'Encomenda concluída!',
    '完成失败': 'Falha ao concluir: ',
    '完成失败重试': 'Falha ao concluir, tente novamente',
    '请输入支付密码': 'Introduza a palavra-passe de pagamento',
    '请先设置支付密码': 'Defina primeiro a palavra-passe de pagamento',
  },
  '入金记录': {
    '标题': 'Histórico de carregamentos',
    '数据为空': 'Sem dados',
    '认证结果': 'Resultado',
    '下单积分': 'Pontos: ',
    '下单时间': 'Encomendado: ',
    '结算时间': 'Liquidado: ',
    '待审核': 'Pendente',
    '已通过': 'Aprovado',
    '已拒绝': 'Rejeitado',
    '暂无数据': 'Sem dados',
  },
  '提现记录': {
    '标题': 'Histórico de levantamentos',
    '数据为空': 'Sem dados',
    '待审核': 'Pendente',
    '审核成功': 'Aprovado',
    '审核退回': 'Rejeitado',
    '未知状态': 'Desconhecido',
    '金额': 'Montante: ',
    '说明': 'Nota: ',
    '提交时间': 'Submetido: ',
    '审核时间': 'Revisado: ',
    '已通过': 'Aprovado',
    '已拒绝': 'Rejeitado',
    '暂无数据': 'Sem dados',
  },
  '资料': {
    '基本信息': 'Perfil',
    '头像': 'Avatar',
    '姓名': 'Nome',
    '未设置': 'Não definido',
    '性别': 'Sexo',
    '男': 'Masculino',
    '女': 'Feminino',
    '未知': 'Desconhecido',
    '设定': 'Definições',
    '账号信息': 'Conta',
    '更改登录密码': 'Alterar palavra-passe de acesso',
    '设定支付密码': 'Definir palavra-passe de pagamento',
    '退出登录': 'Terminar sessão',
    '设置': 'Definições',
    '登录密码': 'Palavra-passe de acesso',
    '资金密码': 'Palavra-passe de fundos',
    '提现密码已设置': 'Palavra-passe de levantamento definida. Contacte o suporte para alterar.',
    '已设置': 'Definido',
    '修改真实姓名': 'Editar nome verdadeiro',
    '请输入真实姓名': 'Introduza o nome verdadeiro',
    '真实姓名说明': 'O nome verdadeiro deve coincidir com os dados da carteira',
    '提交': 'Submeter',
    '请勿重复设置': 'Já definido!',
    '修改登录密码': 'Alterar palavra-passe de acesso',
    '设置资金密码': 'Definir palavra-passe de fundos',
    '保存': 'Guardar',
    '旧密码': 'Palavra-passe antiga',
    '请输入旧密码': 'Introduza a palavra-passe antiga',
    '新密码': 'Nova palavra-passe',
    '请输入新密码': 'Introduza a nova palavra-passe',
    '确认密码': 'Confirmar palavra-passe',
    '请再次输入新密码': 'Introduza novamente a nova palavra-passe',
    '请填写完整': 'Preencha todos os campos!',
    '两次密码不一致': 'As palavras-passe não coincidem',
    '性别修改': 'Editar sexo',
    '个人报表': 'Relatório pessoal',
    '任务金额积分': 'Montante de tarefas (pontos)',
    '盈利公式': 'Lucro = Ganho − Montante de tarefas',
    '任务金额': 'Montante de tarefas',
    '充值金额': 'Carregamento',
    '金额': 'Montante',
    '中奖金额': 'Montante ganho',
    '个人情报': 'Perfil',
    '身高': 'Altura:',
    '胸围': 'Busto:',
    '收费区间': 'Intervalo de preços:',
    '系统公告': 'Anúncios',
  },
  '客服': {
    '联系客服': 'Contactar suporte',
    '在线客服': 'Suporte online',
    '暂无客服': 'Sem suporte disponível',
    '联系': 'Contactar',
    '服务时间': 'Ao seu serviço 24/7',
  },
  '影院': {
    '影院': 'Cinema',
    '全部': 'Tudo',
    '最高分': 'Mais bem avaliados',
    '播放': 'Reproduções: ',
    '次播放': ' reproduções',
    '热门推荐': 'Popular',
    '播放次数': 'Reproduções:',
    '请充值后观看': 'Carregue para ver',
  },
  '语言切换器': {
    '切换语言': 'Idioma',
    '语言': 'Idioma',
  },
}
